<template>
  <section>
    <!--工具条-->
    <el-form
      :inline="true"
      v-if="buttonList != null && buttonList.length > 0"
      :model="filters"
      @submit.native.prevent
    >
      <el-form-item label="学员姓名">
        <el-input v-model="filters.MemberName" placeholder="请输入学员姓名"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="filters.MemberPhone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="证书">
        <el-select v-model="filters.CertificateId" clearable placeholder="请选择证书">
          <el-option label="全部" :value="-1"></el-option>
          <el-option
            v-for="item in certificateList"
            :key="item.Key"
            :label="item.Value"
            :value="item.Key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="邮寄状态">
        <el-select v-model="filters.DeliveryStatus" clearable placeholder="请选择状态">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="无需邮寄" :value="0"></el-option>
          <el-option label="待填写地址" :value="1"></el-option>
          <el-option label="待发货" :value="2"></el-option>
          <el-option label="已发货" :value="3"></el-option>
          <el-option label="已签收" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发放时间">
        <el-date-picker
          v-model="filters.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <el-button
          :type="item.Func && item.Func.toLowerCase().indexOf('export') != -1 ? 'success' : 'primary'"
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table
      :data="tableData"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      style="width: 100%"
    >
      <el-table-column prop="Id" label="ID" width="60"></el-table-column>
      <el-table-column prop="MemberName" label="学员姓名" width="100"></el-table-column>
      <el-table-column prop="MemberPhone" label="手机号" width="120"></el-table-column>
      <el-table-column prop="CertificateName" label="证书名称" width="150"></el-table-column>
      <el-table-column prop="Channel" label="获取途径" width="120"></el-table-column>
      <el-table-column prop="RuleName" label="触发规则" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.RuleName || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="DeliveryStatusName" label="邮寄状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="getStatusType(scope.row.DeliveryStatus)" size="small">
            {{ scope.row.DeliveryStatusName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="证书" width="80">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.CertificatePath"
            type="text"
            size="small"
            @click="viewCertificate(scope.row)"
          >
            查看
          </el-button>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="IssueTime" label="发放时间" width="160" :formatter="formatIssueTime"></el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" width="160" :formatter="formatCreateTime"></el-table-column>
    </el-table>

    <!--分页-->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </section>
</template>

<script>
import {
  CertificateRecordGetList,
  CertificateRecordExport,
  CertificateGetList,
} from '../../api/api'
import { formatDate } from '../../common/js/date'

export default {
  data() {
    return {
      filters: {
        MemberName: '',
        MemberPhone: '',
        CertificateId: -1,
        DeliveryStatus: -1,
        dateRange: null,
      },
      tableData: [],
      listLoading: false,
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      currentRow: null,
      buttonList: [],
      certificateList: [],
    }
  },
  created() {
    this.loadCertificateList()
    this.getModules_search()
  },
  methods: {
    callFunc(item) {
      this[item.Func](item)
    },
    async loadCertificateList() {
      const { data } = await CertificateGetList({ PageIndex: 1, PageSize: 1000 })
      if (data.success) {
        this.certificateList = (data.response.data || []).map(item => ({
          Key: item.Id,
          Value: item.Name,
        }))
      }
    },
    async getModules_search() {
      this.listLoading = true
      const params = {
        PageIndex: this.pageIndex,
        PageSize: this.pageSize,
        MemberName: this.filters.MemberName,
        MemberPhone: this.filters.MemberPhone,
        CertificateId: this.filters.CertificateId,
        DeliveryStatus: this.filters.DeliveryStatus,
        StartTime: this.filters.dateRange ? this.filters.dateRange[0] : null,
        EndTime: this.filters.dateRange ? this.filters.dateRange[1] : null,
      }
      const { data } = await CertificateRecordGetList(params)
      if (data.success) {
        this.tableData = data.response.data
        this.total = data.response.dataCount
        this.buttonList = data.response.buttonList || this.buttonList
        if (this.buttonList.length === 0) {
          this.buttonList = [
            { id: 1, name: '查询', Func: 'getModules_search' },
            { id: 2, name: '导出', Func: 'handleExport' },
          ]
        }
      }
      this.listLoading = false
    },
    selectCurrentRow(row) {
      this.currentRow = row
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getModules_search()
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getModules_search()
    },
    async handleExport() {
      this.listLoading = true
      const params = {
        PageIndex: 1,
        PageSize: 100000,
        MemberName: this.filters.MemberName,
        MemberPhone: this.filters.MemberPhone,
        CertificateId: this.filters.CertificateId,
        DeliveryStatus: this.filters.DeliveryStatus,
        StartTime: this.filters.dateRange ? this.filters.dateRange[0] : null,
        EndTime: this.filters.dateRange ? this.filters.dateRange[1] : null,
      }
      const { data } = await CertificateRecordExport(params)
      this.listLoading = false
      if (data.success && data.response) {
        this.exportToExcel(data.response)
      } else {
        this.$message.error(data.msg || '导出失败')
      }
    },
    exportToExcel(dataList) {
      // 构建CSV内容
      const headers = ['ID', '学员姓名', '手机号', '证书名称', '获取途径', '触发规则', '邮寄状态', '发放时间', '创建时间']
      const rows = dataList.map(item => [
        item.Id,
        item.MemberName,
        item.MemberPhone,
        item.CertificateName,
        item.Channel || '',
        item.RuleName || '',
        item.DeliveryStatusName,
        item.IssueTime ? this.formatDateStr(item.IssueTime) : '',
        this.formatDateStr(item.CreateTime),
      ])

      let csvContent = '\uFEFF' // BOM for UTF-8
      csvContent += headers.join(',') + '\n'
      rows.forEach(row => {
        csvContent += row.map(cell => `"${cell}"`).join(',') + '\n'
      })

      // 下载文件
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `证书发放记录_${new Date().toISOString().slice(0, 10)}.csv`
      link.click()
      this.$message.success('导出成功')
    },
    viewCertificate(row) {
      if (row.CertificatePath) {
        window.open(row.CertificatePath, '_blank')
      }
    },
    getStatusType(status) {
      const types = {
        0: 'info',
        1: 'warning',
        2: 'primary',
        3: 'success',
        4: 'success',
      }
      return types[status] || 'info'
    },
    formatIssueTime(row) {
      if (!row.IssueTime) return '-'
      return formatDate(new Date(row.IssueTime), 'yyyy-MM-dd hh:mm')
    },
    formatCreateTime(row) {
      if (!row.CreateTime) return ''
      return formatDate(new Date(row.CreateTime), 'yyyy-MM-dd hh:mm')
    },
    formatDateStr(dateStr) {
      if (!dateStr) return ''
      return formatDate(new Date(dateStr), 'yyyy-MM-dd hh:mm')
    },
  },
}
</script>

<style scoped>
</style>
